<template>
    <div>
        <b-modal v-model="showReleaseFormManager" size="lg" @ok="handleReleaseFormDidSelectItems" :ok-disabled="!releaseFormModalOk">
            <release-form-manager
                    ref="releaseFormManager"
                    @releaseFormSelected="releaseFormModalOk = true"
                    @releaseFormCleared="releaseFormModalOk = false"
                    :accepted-files="releaseFormAcceptedFiles"
                    :initial-release-forms="submissionReleaseForms"
                    :release-form-url="releaseFormUrl"/>
        </b-modal>

        <b-row>
            <b-col>
                <release-form-list ref="releaseFormList"
                                   :asset="asset"
                                   :assets-url="assetUrl"
                                   :initial-release-forms="releaseForms"
                                   @releaseRequiredEditableChanged="releaseRequiredEditable = arguments[0]"/>
            </b-col>
            <b-col cols="auto">
                <b-button variant="secondary"
                          size="sm"
                          @click="handleAddRelease">Add Release Form
                </b-button>
                <b-button variant="secondary"
                          size="sm"
                          @click="changeReleaseRequired"
                          v-if="releaseRequiredEditable">
                    No Release Needed
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import ReleaseFormManager from '../../ReleaseForms/ReleaseFormManager'
  import ReleaseFormList from '../../ReleaseForms/ReleaseFormList'
  import generalMixins from "../../../mixins/GeneralMixins";

  export default {
    props: ['assetUrl', 'releaseFormUrl', 'asset', 'acceptedFiles', 'releaseFormAcceptedFiles', 'submissionReleaseForms'],

    data: function () {
      return {
        releaseRequiredEditable: false,
        showReleaseFormManager: false,
        selectedReleaseForm: null,
        releaseForms: this.asset.release_forms || [],
        releaseFormModalOk: false
      }
    },

    methods: {
      handleReleaseFormDidSelectItems: function () {
        this.selectedReleaseForm = this.$refs.releaseFormManager.selectedReleaseForm;
        if (this.selectedReleaseForm) {
          const releaseFormIds = this.releaseForms.map(r => r.id);
          if (!releaseFormIds.includes(this.selectedReleaseForm.id)) {
            releaseFormIds.push(this.selectedReleaseForm.id);

            this.$http.patch(`${this.assetUrl}/${this.asset.id}`, {
              asset: {
                release_form_ids: releaseFormIds
              }
            }).then(fulfill => {
              this.releaseForms.push(this.selectedReleaseForm);
            }, rejected => {
              this.showErrorToast("There was an error updating the asset");
            });
          }
        }
      },

      handleAddRelease: function () {
        this.showReleaseFormManager = true;
      },

      changeReleaseRequired: function () {
        this.$refs.releaseFormList.handleReleaseRequiredToggle();
      }
    },

    mixins: [generalMixins],

    components: {ReleaseFormList, ReleaseFormManager}
  }
</script>